<template>
  <el-dialog
          title="团队代理明细"
          :visible.sync="dialogVisible"
          customClass="customWidth"
          @opened="dialogOpen"
  >
    <div class="header" flex="main:justify cross:center">
      <el-form
              :inline="true"
              :model="searchForm"
              ref="searchForm"
              size="mini"
              style="margin-bottom: -18px;"
      >

        <el-form-item
        >
          <el-date-picker
                  v-model="pickerValue"
                  type="daterange"
                  align="right"
                  size="small"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 300px;"
                  value-format="yyyy-MM-dd" format="yyyy-MM-dd">
            ></el-date-picker>
        </el-form-item>

        <el-form-item
        >
          <el-input
                  v-model="searchForm.user_agentid"
                  placeholder="代理编号"
                  style="width: 120px;"
          />
        </el-form-item>


        <el-form-item
        >
          <el-input
                  v-model="searchForm.legal"
                  placeholder="姓名"
                  style="width: 120px;"
          />
        </el-form-item>
        <el-form-item
        >
          <el-input
                  v-model="searchForm.mobileno"
                  placeholder="手机号码"
                  style="width: 120px;"
          />
        </el-form-item>



        <el-form-item>
          <el-button
                  type="primary"
                  @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="header2" flex="main:justify cross:center">
      订单总数 {{order_num}}笔； 订单总金额 {{wz_num_bf}}元； 微信总金额 {{wx_num_bf}}元； 支付宝总金额 {{zfb_num_bf}}元； 微信总数 {{yhk_num_bf}}笔； 支付宝总数 {{fyk_num_bf}}笔
    </div>
    <el-table
            :data="tableData"
            v-loading="loading"
            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >
      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
      </el-table-column>

      <el-table-column
              label="代理编号"
      >
        <template slot-scope="scope">
          {{scope.row.agentid}}
        </template>
      </el-table-column>

      <el-table-column
              label="微信名称"
      >
        <template slot-scope="scope">
          {{scope.row.username}}
        </template>
      </el-table-column>
      <el-table-column
              label="微信头像"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.avatarUrl!=null && scope.row.avatarUrl!=''">
            <img :src= "getImgUrl33(scope.row.avatarUrl)" style="width: 100px;height: 100px; "/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="手机号码"
      >
        <template slot-scope="scope">
          {{scope.row.mobileno}}
        </template>
      </el-table-column>
      <el-table-column
              label="姓名"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>
      <el-table-column
              label="账号类型"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.dl_type=='-1'">
            平台
          </div>
          <div v-else-if="scope.row.dl_type=='0'">
            全国代理
          </div>
          <div v-else-if="scope.row.dl_type=='1'">
            运营商
          </div>
          <div v-else-if="scope.row.dl_type=='2'">
            服务商
          </div>
          <div v-else-if="scope.row.dl_type=='5'">
            运营中心
          </div>


        </template>
      </el-table-column>
      <el-table-column
              label="注册时间"
      >
        <template slot-scope="scope">
          {{scope.row.create_times}}
        </template>
      </el-table-column>
      <el-table-column
              label="直推商家数"
      >
        <template slot-scope="scope">
          {{scope.row.sl}}
        </template>
      </el-table-column>
      <el-table-column
              label="直推商家交易总额"
      >
        <template slot-scope="scope">
          {{scope.row.je}}
        </template>
      </el-table-column>

      <el-table-column
              label="级别"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.level=='1'">
            直推
          </div>
          <div v-else> 间推</div>
        </template>
      </el-table-column>


    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:90%;
  }
</style>
<script>
  import * as agentService from "@/api/sys/agent";
  import * as userService from "@/api/sys/user";
  import util from '@/libs/util.js'
  export default {
    name: "threeagentEditForm",
    props: {
      agentid: String,
      value: Boolean
    },
    data() {
      return {
        wz_num_bf:'0',
        order_num:'0',
        wx_num_bf:'0',
        zfb_num_bf:'0',
        yhk_num_bf:'0',
        fyk_num_bf:'0',
        loading: false,
        dialogVisible: false,
        tableData: [],
        pickerValue: [],

        searchForm: {
          user_agentid:"",
          legal:"",
          mobileno:""
        },
        page: {
          current: 1,
          size: 10,
          total: 0
        },
        sort: {
          prop: "",
          order: ""
        }
      };
    },
    watch: {
      value(val) {
        this.dialogVisible = val;
      },
      dialogVisible(val) {
        this.$emit("input", val);
      }
    },
    methods: {
      dateConversion(value){
        var d = new Date(value);
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        console.info("===========date========="+date);
        return date;
      },
      dialogOpen() {
        this.$refs.searchForm.resetFields();
        this.getTableData33();
        this.getTableDataMx();

      },
      getTableDataMx() {
        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("agentid",this.agentid);
        if(this.pickerValue!=null) {
          formData4.append("start_time", this.pickerValue[0]);
          formData4.append("end_time", this.pickerValue[1]);
          console.info("pay_type======" + this.pickerValue[0]);
        }


        agentService.getStatistiSales(formData4).then(data => {
          if(data!=null && data!=""){
            this.wz_num_bf=data.wz_num_bf;
            this.order_num=data.order_num;
            this.wx_num_bf=data.wx_num_bf;
            this.zfb_num_bf=data.zfb_num_bf;
            this.yhk_num_bf=data.yhk_num_bf;
            this.fyk_num_bf=data.fyk_num_bf;

          }
        });

        //

      },
      getTableData33() {
        if(this.pickerValue==null){
          this.pickerValue="";
        }
        console.info("===========ddddddddd========="+this.pickerValue[0]);
        let query = {
          pageIndex: this.page.current,
          pageSize: this.page.size,
          sortBy: this.sort.prop,
          agentid: this.agentid,
          start_time:this.pickerValue[0],
          end_time:this.pickerValue[1],
          descending: this.sort.order === "descending",
          filter: this.searchForm
        };
        agentService.getMobileOrderPagelistDlSales(query).then(data => {
          this.tableData = data.rows;
          this.page.total = data.totalCount;
        });
      },
      handleSearchFormSubmit() {
        this.getTableData33();
        this.getTableDataMx();
      },
      handleSearchFormReset() {
        this.$refs.searchForm.resetFields();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleSortChange(val) {
        this.sort.prop = val.prop;
        this.sort.order = val.order;
        this.getTableData33();
      },
      handleSizeChange(val) {
        this.page.size = val;
        this.getTableData33();
      },
      handleCurrentChange(val) {
        this.page.current = val;
        this.getTableData33();
      },
      getImgUrl33(url){
        return url;
      },
      close() {
        this.$refs["searchForm"].resetFields();
        this.dialogVisible = false;
      }
    }
  };
</script>
<style lang="scss" scoped>
  .header {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .header2 {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
